import React, { useState, useEffect } from 'react';
import dataProvider from '../../lib/dataProvider';
import { getInfoValue, isHauptadmin } from '../../lib/globalData';
import { useTranslate } from 'react-admin';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';


const Info = ({data}) => {
  const tr = useTranslate();
  const hostelName = getInfoValue('hostelname')
  return (
    <Box sx={{ p: '2em', pb: 0 }}>
      <Box sx={{ mb: '1em' }}>
        {tr('bw.set.acquirer.intro1')}
        <a href="http://stripe.com" target="_blank" rel="noreferrer">Stripe</a>
        {tr('bw.set.acquirer.intro2')}
      </Box>
      <Box sx={{ mb: '1em' }}>
        {tr('bw.set.acquirer.intro3')}
        <a href="http://de.wikipedia.org/wiki/Payment_Card_Industry_Data_Security_Standard" target="_blank" rel="noreferrer">PCI-DSS</a>
        {tr('bw.set.acquirer.intro4')}
        <a href="http://stripe.com" target="_blank" rel="noreferrer">Stripe</a>
        {tr('bw.set.acquirer.intro5')}
      </Box>
      <Box sx={{mb: '1em' }}>
        {tr('bw.set.acquirer.intro6')}
      </Box>
      <Box sx={{ mb: '1em' }}>
        {tr('bw.set.acquirer.intro7')}
        <a href="https://support.stripe.com/questions/what-countries-does-stripe-support" target="_blank" rel="noreferrer">{tr('bw.set.acquirer.intro8')}</a>
        {tr('bw.set.acquirer.intro9')}
      </Box>
      <Box sx={{ mb: '1em' }}>
        (1) 
        {tr('bw.set.acquirer.introOpt1p1')}<b>{tr('bw.set.acquirer.introOpt1p2')}</b>{tr('bw.set.acquirer.introOpt1p3')}
        <a href="https://stripe.com/global" target="_blank" rel="noreferrer">{tr('bw.set.acquirer.introOpt1p4')}</a>
        {tr('bw.set.acquirer.introOpt1p5')}
      </Box>
      <Box sx={{ mb: '1em' }}>
        (2) 
        {tr('bw.set.acquirer.introOpt2p1')}
        <b>{tr('bw.set.acquirer.introOpt2p2')}</b>
        {tr('bw.set.acquirer.introOpt2p3')}
        <a href="https://stripe.com/global" target="_blank" rel="noreferrer">{tr('bw.set.acquirer.introOpt2p4')}</a>
        {tr('bw.set.acquirer.introOpt2p5', {hostel: hostelName})}
        <a href={"https://connect.stripe.com/oauth/authorize?response_type=code&stripe_landing=login&scope=read_write&state="+data?.url_key+"&client_id="+data?.url_id} target="_blank" rel="noreferrer" class="stripe-connect">{tr('bw.set.acquirer.introOpt2p6', {hostel: hostelName})}</a>
      </Box>
      <Box sx={{ mb: '1em' }}>
        (3) 
        {tr('bw.set.acquirer.introOpt3p1')}
        <b>{tr('bw.set.acquirer.introOpt3p2')}</b>
        {tr('bw.set.acquirer.introOpt3p3')}
        <b>{tr('bw.set.acquirer.introOpt3p4')}</b>
        {tr('bw.set.acquirer.introOpt3p5')}<br />
        <a href={"https://connect.stripe.com/oauth/authorize?response_type=code&stripe_landing=register&scope=read_write&state="+data?.url_key+"&client_id="+data?.url_id} target="_blank" rel="noreferrer" class="stripe-connect">{tr('bw.set.acquirer.introOpt3p6', {hostel: hostelName})}</a>
      </Box>
      <Box>
        {tr('bw.set.acquirer.introFinal')}
      </Box>
    </Box>
  )
}

const Merchant = () => {
  const tr = useTranslate();
  return (
    <Box sx={{ p: '2em', pb: 0 }}>
      <Box sx={{ mb: '1em' }}>
        {tr('bw.set.acquirer.merchant1')}
        <b>Merchant Category</b>
        {tr('bw.set.acquirer.merchant2')}
        <b>7011 (Hotels)</b>
        {tr('bw.set.acquirer.merchant3')}
        <a href="mailto:support@stripe.com?subject=Merchant Category &body=Dear Strip Support,%0APlease check the Merchant Category of my Stripe-Account. May the category 7011 (Hotel) would be good.%0a%0aKind Regards,%0a">support@stripe.com</a>
        {tr('bw.set.acquirer.merchant4')}
      </Box>
    </Box>
  )
}

const ConInfo = () => {
  const tr = useTranslate();
  return (
    <Box sx={{ p: '2em', pb: 0 }}>
      <Box sx={{ mb: '1em' }}>
        {tr('bw.set.acquirer.conInfo1')}
        <a href="http://stripe.com" target="_blank" rel="noreferrer">Stripe</a>
        {tr('bw.set.acquirer.conInfo2')}
      </Box>
      <Box>
        {tr('bw.set.acquirer.moreInfo')}:<br /> 
        - <a href="http://de.wikipedia.org/wiki/Payment_Card_Industry_Data_Security_Standard" target="_blank" rel="noreferrer">PCI-DSS</a><br /> 
        - <a href="https://support.stripe.com/questions/what-countries-does-stripe-support" target="_blank" rel="noreferrer">
        {tr('bw.set.acquirer.stripeCountries')}
        </a><br /> 
      </Box>
    </Box>
  )
}

const AccInfo = ({data}) => {
  return (
    <Box sx={{ p: '2em', pb: 0 }}>
      <Box sx={{ mb: '1em' }}>
        current stripe user: {data?.str_user}<br />
        connected: {data?.connected}<br />
        storePaymentInfo: {data?.storePaymentInfo}<br />
        storeInfo: {data?.storeInfo}<br />
      </Box>
      <Box>
        backward check: {data?.backward_check}<br />
      </Box>
    </Box>
  )
}

const DeleteForm = () => {
  const hostel_id = getInfoValue('id_hostel')
  const [confirm, setConfirm] = useState(false)
  const [said, setSaid] = useState(false)
  const [progress, setProgress] = useState(false)
  const [res, setRes] = useState({log:''})

  const handleDeactivate = () => {
    setProgress(true)
    dataProvider.update('setAcquirer/deactivate', { id: hostel_id, data: { said: said } })
    .then(res  => {
      setConfirm(false)
      setProgress(false)
      setRes(res.data)
    })
  }

  return (
    <Box sx={{ p: '2em', pb: 0 }}>
      <Box sx={{ padding: '1em', border: '2px solid red', borderRadius: '10px', maxWidth: '30em' }}>
        <b>Stripe-Konto deaktivieren</b> Hostel-ID: {hostel_id}
        <div><span style={{paddingTop: '1em', paddingRight: '.5em', display: 'inline-block'}}>Stripe-Account-ID: </span><TextField onChange={ev=>setSaid(ev.target.value)} variant="outlined" size="small" inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} /></div>
        <div><Checkbox checked={confirm} onChange={(ev)=>setConfirm(ev.target.checked)} /> Ich m&ouml;chte dieses Stripe-Konto wirklich deaktivieren</div>
        { confirm && <div>
          <Button onClick={()=>handleDeactivate()} variant="contained" sx={{ backgroundColor: 'red'}}>Stripe deaktivieren</Button>
          { progress && <CircularProgress size="2em" sx={{ ml: '1em', position: 'absolute' }} /> }
        </div>}
        { res?.error && <div style={{color: 'red'}}>{res.error.map(e=><div>{e}</div>)}</div>}
        { res?.success && <div>
          <div style={{color: 'green'}}>{res.success}</div>
          <div>{res?.log.map(l=><div>{l}</div>)}</div>
        </div>}
      </Box>
    </Box>
  )
}

const OrphanRows = ({data, handleDisconnect, progress}) => {
  if(!data || data.length < 1)return
  return (
    <table border='1' cellpadding='4' cellspacing='0' style={{borderCollapse: 'collapse', marginTop: '1em'}}>
      <thead>
      <tr style={{backgroundColor:'#eee'}}>
        <th>acct_id</th>
        <th>Business Name</th>
        <th>Dashboard Name</th>
        <th>Email</th>
        <th>Country</th>
        <th>Charges</th>
        <th>Payouts</th>
        <th>Created</th>
        <th>Type</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      { data.map(el=><tr key={'tr'+el.acct_id}>
        <td>{el.acct_id}</td>
        <td>{el.bname}</td>
        <td>{el.dname}</td>
        <td>{el.email}</td>
        <td>{el.country}</td>
        <td>{el.charges}</td>
        <td>{el.payouts}</td>
        <td>{el.created}</td>
        <td>{el.type}</td>
        <td>{el.link && <div>
          <Button onClick={()=>handleDisconnect(el.acct_id)} variant="contained" sx={{ backgroundColor: 'red'}}>Disconnect</Button>
          { progress && <CircularProgress size="2em" sx={{ ml: '1em', position: 'absolute' }} /> }
        </div>}</td>
      </tr>)}
      </tbody>
    </table>
  )
}

const Orphans = () => {
  const hostel_id = getInfoValue('id_hostel')
  const [data, setData] = useState([]);
  const [res, setRes] = useState({log:''})
  const [progress, setProgress] = useState(false)

  const getOrphans = () => {
    dataProvider.getOne('setAcquirer/orphans', { id: hostel_id })
      .then(res  => {
        console.log(res)
        if(res.data.orphans)setData(res.data.orphans)
      })
  }

  const handleDisconnect = (id) => {
    setProgress(true)
    dataProvider.update('setAcquirer/disconnect', { id: hostel_id, data: { said: id } })
    .then(res  => {
      setProgress(false)
      setRes(res.data)
    })
  }

  return (
    <Box sx={{ p: '2em', pb: 0 }}>
      <Button onClick={()=>getOrphans()} variant="contained">Verwaiste Stripe-Konten (nicht mehr im thostel)</Button>
      { data && <OrphanRows data={data} handleDisconnect={handleDisconnect} progress={progress} />}
      { res?.error && <div style={{color: 'red', marginTop:'1em', fontWeight: 'bold'}}>{res?.error}</div>}
      { res?.success && <div>
        <div style={{color: 'green', marginTop:'1em', fontWeight: 'bold'}}>{res.success}</div>
      </div>}
    </Box>
  )
}

const Acquirer = () => {
  const tr = useTranslate();
  const [data, setData] = useState({});
  
  useEffect(() => {
    setData({})
    dataProvider.getOne('setAcquirer', { id: getInfoValue('id_hostel') })
      .then(res  => {
        if(res.data)setData(res.data)
      })
  }, []);
  
  if(!data?.id)return
  return (         
    <Paper style={{scroll:'auto', paddingBottom: '2em'}} >
      <div style={{ fontWeight: 'bold', fontSize: '2em', marginTop: '3em', marginLeft: '.25em' }}>{tr('bw.set.acquirer.title')}</div>
      { (!data.stripeactive) && <Info data={data} />}
      <Merchant />
      { (data.stripeactive) && <ConInfo />}
      { isHauptadmin() && <>
        <AccInfo data={data} />
        <DeleteForm />
        <Orphans />
      </>}
    </Paper>
  )
}
export default Acquirer;